// extracted by mini-css-extract-plugin
module.exports = {"otherFiles":"CbFileDisplay_otherFiles__C2L6e"};